const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveMediaUrl(url, backendOrigin = BACKEND_ORIGIN) {
  if (url == null || url === "") return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/api/")) return `${String(backendOrigin || "").replace(/\/$/, "")}${url}`;
  return url;
}

export function mediaRecordUrl(media) {
  return resolveMediaUrl(media?.file_url || media?.url || "");
}

export function isImageMedia(media) {
  if (media?.file_type) return media.file_type === "image";
  return typeof media?.mime === "string" && media.mime.startsWith("image/");
}

export function findMediaUrl(items, mediaId) {
  if (!mediaId || !Array.isArray(items)) return "";
  return mediaRecordUrl(items.find((item) => item?.id === mediaId));
}
